<template>
  <div class="actions">
    <input class="actions-search" v-if="isOpen" v-model="terms" v-on:input="search" type="text">

    <a class="actions-toggle" v-on:click.prevent="toggleSearch" href="#">
      <i v-if="isOpen" class="fas fa-times"></i>
      <i v-if="!isOpen" class="fas fa-search"></i>
    </a>

    <DropDownMenu :menus="menus" class="ml-2" />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import DropDownMenu from'@/components/common/DropDownMenu.vue';
  import EventBus from '@/eventbus';

  export default {
    components: { DropDownMenu },
    data() {
      return {
        isOpen: false,
        menus: [
          {
              external: true,
              iconClass: "fa-print",
              title: "Print",
              action: function () { EventBus.$emit("printDayTemplate"); }
          },
          {
              external: true,
              iconClass: "fa-file-export",
              title: "Export CSV",
              action: function () { EventBus.$emit("exportDayTemplate"); }
          }
        ],
        terms: ''
      }
    },
    computed: {
      ...mapState(["currentDayTemplate"]),
    },
    methods: {
      toggleSearch() {
        this.isOpen = !this.isOpen;

        if (!this.isOpen) {
          EventBus.$emit('planningSearch', '');
        } else {
          EventBus.$emit('planningSearch', this.terms);
        }
      },
      search() {
        EventBus.$emit('planningSearch', this.terms);
      }
    }
  }
</script>

<style scoped lang="scss">
  .actions {
    display: flex;
    align-items: center;

    &-toggle {
      flex-shrink: 0;
      position: relative;
      width: 24px;
      height: 24px;
      margin-left: 12px;

      i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    &-search {
      height: 24px;
      padding: 0;
      width: 200px;
    }
  }
</style>
